export const SELLER = {
  mps: {
    name: '주식회사 마플코퍼레이션',
    ceo: '박혜윤',
    num: '107-86-46373',
    tel: '1566-2945',
    address: '서울특별시 금천구 가산디지털1로 75-24 아이에스비즈타워 10층',
  },
  nexon: {
    name: '㈜넥슨코리아',
    ceo: '강대현·김정욱',
    num: '220-87-17483',
    tel: '1588-7701',
    address: '경기도 성남시 분당구 판교로 256번길 7',
  },
};

export const PROVIDER = {
  html5_inicis: {
    name: '(주)케이지이니시스',
    ceo: '이선재',
    num: '220-**-*****',
    tel: '1034*******',
    address: '서울특별시 중구 통일로 92 (KG타워 14, 15층)',
  },
  naverpay: {
    name: '네이버파이낸셜㈜ ',
    ceo: '박상진',
    num: '524-**-*****',
    tel: '0106*******',
    address: '경기도 성남시 분당구 정자일로 95, NAVER 1784 (13561)',
  },
  uplus: {
    name: '토스페이먼츠 주식회사',
    ceo: '임한욱',
    num: '411-**-*****',
    tel: '1544*****',
    address: '서울특별시 강남구 테헤란로 131, 14층 (역삼동,한국지식재산센터)',
  },
};
